import { createRouter, createWebHistory, RouteRecordRaw } from "vue-router";
import HomeView from "../views/HomeView.vue";
import MobileAppView from "../views/MobileAppView.vue";
import ProjectsView from "../views/ProjectsView.vue";

const routes: Array<RouteRecordRaw> = [
  {
    path: "/",
    name: "home",
    component: HomeView,
    meta: { title: "Home Page" },
  },
  {
    path: "/mobile-apps",
    name: "mobile-apps",
    component: MobileAppView,
    meta: { title: "Mobile App Page" },
  },
  {
    path: "/projects",
    name: "projects",
    component: ProjectsView,
    meta: { title: "Projects Page" },
  },
];

const router = createRouter({
  history: createWebHistory(),
  routes,
  scrollBehavior(to) {
    if (to.hash) {
      return {
        el: to.hash,
        behavior: "smooth",
      };
    }

    return { top: 0 };
  },
});

export default router;
